<div class="appform-quick-guide">
    <div class="appform-quick-info">
        <p>First Name</p>
        <h5>{{firstName}}</h5>
    </div>
    <div class="appform-quick-info">
        <p>Last Name</p>
        <h5>{{lastName}}</h5>
    </div>
    <div class="appform-quick-info">
        <p>E-mail Address</p>
        <h5>{{emailAddress}}</h5>
    </div>
    <div class="appform-quick-info">
        <p>Phone Number</p>
        <h5>{{phoneNumber}}</h5>
    </div>
</div>